import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(0),
    },
  },
  button: {
    color: theme.palette.common.white,
  },
}));

export default function NotificationIcon(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <IconButton className={classes.button}>
        <Badge badgeContent={props.count} color="error">
          <NotificationsActiveIcon />
        </Badge>
      </IconButton>
    </div>
  );
}
